import script from "./UnSupportedBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnSupportedBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./UnSupportedBrowser.vue?vue&type=style&index=0&id=1240bf02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1240bf02"]])

export default __exports__